import { Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SubscriptionContainer } from 'app/modules/common/helpers/SubscriptionsContainer';
import { SharedService } from 'app/modules/common/services/shared-service';
import { IDropDown } from 'app/modules/fuse/intefaces/IDropDown';
import { SendingService } from 'app/modules/fuse/services/sending.service';
import moment from 'moment';

@Component({
    selector: 'app-task-popup',
    templateUrl: './task-popup.component.html',
    styleUrls: ['./task-popup.component.scss'],
    standalone: false
})
export class TaskPopupComponent implements OnInit {

    private subs: SubscriptionContainer;
    public taskForm: UntypedFormGroup;
    public DateFilterType = DateFilterTypes;
    public allDoctors = [];
    public admintrativeUsers = [];
    public hideElMedicoInput: boolean;
    public hideEnviadasDateField: boolean;
    public hideHastaFechaDateField: boolean;
    public SelectedDoctor: any;
    public SelectedAdministrativeUser: any;
    public selectedReport: any;
    public currentDate: any;
    public datesplitArrey:any []
    @ViewChild('medicoSelect')doctorSearchInput :ElementRef
    _medicoList :any=[];
    public grupoDeEnvioTypes: IDropDown[] =
        [
            { value: 'one-week-0', viewValue: 'Médicos con envío de tareas a una semana' },
            { value: 'one-day-1', viewValue: 'Médicos con envío de tareas del días siguiente' },
            { value: 'all-2', viewValue: 'Médicos con envío de todas las tareas' }
        ];
    administrativeUsers: any;

    constructor(
        private dialogRef: MatDialogRef<TaskPopupComponent>,
        private _sharedService: SharedService,
        private _sendingService: SendingService,
        private _fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) private users
    ) {   
        this.allDoctors = users.medicos;
        this._medicoList=users.medicos;
        this.admintrativeUsers = users.admintrativeUsers;
        
    }

    ngOnInit(): void {
        this.hideElMedicoInput = false;
        this.hideEnviadasDateField = true;
        this.hideHastaFechaDateField = true;

        this._sendingService.selectedCompanyId = localStorage.getItem('Empresa');

        this.createNotificationForm();   
        this.setCurrentDate();
    }
    SearchDoctors()
    {        
      const searchInput=this.doctorSearchInput.nativeElement.value ?
        this.doctorSearchInput.nativeElement.value.toLowerCase():'';
  
      this._medicoList =this.allDoctors.filter(m=>{
        if(m.nombre!=null)
        {
            const viewValue : string=m.nombre.toLowerCase();
            return viewValue.indexOf(searchInput) > -1;
        }
      }) 
    }

    private setCurrentDate() {
        this.currentDate = moment().add(7, 'd').format("DD/MM/YYYY");
    }

    public getFormControl(formControlName: string): UntypedFormControl {
        return this.taskForm.get(formControlName) as UntypedFormControl;
    }

    public onDoctorChange(event: any) {
        this.SelectedDoctor = event.value;
    }

    public onAdminUserChange(event: any) {
        this.SelectedAdministrativeUser = event.value;
        // this._medicoList=this.admintrativeUsers;
        // this.allDoctors=this.admintrativeUsers;
        setTimeout(() => {
          this.doctorSearchInput.nativeElement.value=null;
        }, 1000);
    }

    public onEnvioChange(event) {
        if ('one-week-0' == event.value) {
            this.currentDate = moment().add(7, 'd').format("DD/MM/YYYY");
        } else if ('one-day-1' == event.value) {
            this.currentDate = moment().add(1, 'd').format("DD/MM/YYYY");
        } else if ('all-2' == event.value) {
            this.currentDate = '';
        }
        this.taskForm.get('GrupoDeEnvio').setValue(event.value);
    }

    private createNotificationForm() {
        this.taskForm = this._fb.group({
            Enviar: ["all"],
            SelectedDoctor: [''],
            SelectedAdministrativeUser: [''],

            Tareas: ["Enviadas"],
            DateFrom: ['', Validators.required],
            DateTo: ['', Validators.required],

            GrupoDeEnvio: ['one-week-0'],

            HastaDate: ['', Validators.required],
            FechaDeTarea: ["HastaFecha"],

            SelectedCompanyId: [this._sendingService.selectedCompanyId]
        });
    }

    public enviarChangeHandler(e): void {
        if ("single" === e.target.value) {
            this.hideElMedicoInput = true;
            this.taskForm.get('SelectedDoctor').setValidators([Validators.required]);
            this.taskForm.get('SelectedDoctor').untouched;
            this.taskForm.updateValueAndValidity();
        } else {
            this.hideElMedicoInput = false;
            this.taskForm.get('SelectedDoctor').clearValidators();
            this.taskForm.get('SelectedDoctor').reset();
            this.taskForm.get('SelectedDoctor').untouched;
            this.taskForm.get('SelectedDoctor').valid;
            this.taskForm.updateValueAndValidity();
        }
    }

    public tareasChangeHandler(e): void {
        if ("Enviadas" === e.target.value) {
            this.hideEnviadasDateField = true;
            this.taskForm.get('DateFrom').setValidators([Validators.required]);
            this.taskForm.get('DateFrom').untouched;
            this.taskForm.get('DateTo').setValidators([Validators.required]);
            this.taskForm.get('DateTo').untouched;
            this.taskForm.updateValueAndValidity();
        } else if ("Todas" === e.target.value || "PendientesDeNotificarEliminacion" === e.target.value) {
            this.hideEnviadasDateField = false;
            this.taskForm.get('DateFrom').clearValidators();
            this.taskForm.get('DateFrom').reset();
            this.taskForm.get('DateFrom').untouched;
            this.taskForm.get('DateFrom').valid;
            this.taskForm.get('DateTo').clearValidators();
            this.taskForm.get('DateTo').reset();
            this.taskForm.get('DateTo').untouched;
            this.taskForm.get('DateTo').valid;
            this.taskForm.updateValueAndValidity();
        }
    }

    public fechaDeTareaChangeHandler(e): void {
        if ("HastaFecha" === e.target.value) {
            this.hideHastaFechaDateField = true;
            this.taskForm.get('HastaDate').setValidators([Validators.required]);
            this.taskForm.get('HastaDate').markAsTouched();
            this.taskForm.updateValueAndValidity();
        } else if ("FdTodas" === e.target.value || "Hasta" === e.target.value) {
            this.hideHastaFechaDateField = false;
            this.taskForm.get('HastaDate').clearValidators();
            this.taskForm.get('HastaDate').reset();
            this.taskForm.get('HastaDate').untouched;
            this.taskForm.get('HastaDate').valid;
            this.taskForm.updateValueAndValidity();
        }
    }

    public setFilterValues(filterType: string, data: Date = null): void {
        switch (filterType) {
            case 'commonDateFrom':
                this.taskForm.patchValue({ DateFrom: DateHelper.getUTCDateString(data) });
                break;
            case 'commonDateTo':
                this.taskForm.patchValue({ DateTo: DateHelper.getUTCDateString(data) });
                break;
            default:
                break;
        }
    }
  

    private setDateNormalFormat() {
        this.taskForm.patchValue({ HastaDate: DateHelper.getUTCDateString(this.taskForm.get('HastaDate').value.toDate()) });
    }

    public onSubmit(): void {

        this.taskForm.markAllAsTouched();

        if (this.taskForm.get('HastaDate').value !== '' && this.taskForm.get('HastaDate').value !== null) {
            this.setDateNormalFormat();
        }
        //Check date status 
        if(this.taskForm.get('DateFrom').value!=null)
        {
            this.datesplitArrey=this.taskForm.get('DateFrom').value.toString().split("-")
            if(this.datesplitArrey[0].length==3)
            {
                this.taskForm.get('DateFrom').setErrors({'incorrect': true})   
            }
        }
       
        this.datesplitArrey=[];
        if(this.taskForm.get('DateTo').value!=null)
        {
            this.datesplitArrey=this.taskForm.get('DateTo').value.toString().split("-")
            if(this.datesplitArrey[0].length==3)
            {
                this.taskForm.get('DateTo').setErrors({'incorrect': true}) 
            }
        }

        if (this.taskForm.valid) {
            this._sendingService.Tareas(this.taskForm.value).subscribe(res => {
                if (res.code === 0) {
                    this._sharedService.ShowSnackBar(res.result);
                } else {
                    this._sharedService.ShowSnackBar(res.message || 'lo siento, el proceso falló');
                }
            }, error => {
                this._sharedService.ShowSnackBar('api Se produjo un error');
                console.error(error);
            });

            this.close();
        }
    }

    public close(): void {
        this.dialogRef.close();
    }

    public onCompanySelcted(e) {
        this.taskForm.controls["SelectedCompanyId"].setValue(e.id);
    }
}
